import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BatchAlertService } from 'src/app/services/batch-alert.service';

@Component({
  selector: 'app-delete-batch-alert',
  templateUrl: './delete-batch-alert.component.html',
  styleUrls: ['./delete-batch-alert.component.scss']
})
export class DeleteBatchAlertComponent {
  deleteMsg: boolean = true;

  constructor(
    public dialog: MatDialog,
    public batchAlertService: BatchAlertService
    ) { }

  exitModal(){
    this.dialog.closeAll();
  }

  progressDeleted(){
    this.deleteMsg = false;
    this.batchAlertService.deleteBatchAlert();
  }


 

}
